import React from 'react';
import styled, { css } from 'styled-components';
import { RichText } from '../rich-text/general/rich-text';
import Scrollbar from 'react-scrollbars-custom';
import { Brand } from '../../../embedding/dwt-app';

export const TOOLTIP_ID = 'global-brand-tooltip';

const Arrow = styled.div.attrs({ className: 'tooltip-arrow' })<{ borderColor?: string }>`
  left: calc(50% - 4px);
  bottom: -4px;
  border-bottom: 1px solid transparent;
  border-right: 1px solid transparent;
  transform: rotate(45deg);
  width: 8px;
  height: 8px;
  position: absolute;
  background: inherit;
  ${(p) =>
    p.borderColor &&
    css`
      border-color: ${p.borderColor};
    `};
`;

const BaseTooltipStyle = styled.div`
  background: white !important;
  font-size: 16px !important;
  display: inline-block;
  color: #787b80 !important;
  border-radius: 0 !important;
  z-index: 3000 !important;
  padding: 10px !important;
  margin: 0;
  opacity: 0;
  border: 1px solid black;
  transition: all 0.3s ease-in-out;
  pointer-events: all;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03) !important;

  &.visible {
    opacity: 1;
  }
`;

const CitBaseTooltipStyle = styled(BaseTooltipStyle)`
  border-radius: 8px !important;
  border-color: transparent !important;
  color: #333333 !important;
  padding: 12px !important;
  font-size: 12px;
  word-break: break-word;
  hyphens: auto;
  font-family: 'Citroen', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #e4e2e2 !important;
    border-radius: 2px !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #da291c !important;
    border-radius: 2px !important;
  }
`;

const PeuBaseTooltipStyle = styled(BaseTooltipStyle)`
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  border-color: transparent !important;
  position: relative;
  cursor: pointer;
  margin: 0;
  color: black !important;
  font-family: 'PeugeotNormal', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #ececee !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #0074e8 !important;
    border-radius: 0 !important;
  }
`;

const DsBaseTooltipStyle = styled(BaseTooltipStyle)`
  position: relative;
  cursor: pointer;
  font-size: 20px;
  margin: 0;
  padding: 16px !important;
  border-color: #9d8c83 !important;
  font-family: 'DSAutomobiles', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #e9e7e1 !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #9d8c83 !important;
    border-radius: 0 !important;
  }

  p {
    line-height: unset !important;
  }
`;

const OpelBaseTooltipStyle = styled(BaseTooltipStyle)`
  cursor: pointer;
  display: inline-flex;
  width: fit-content;
  margin: 0;
  border-color: transparent !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: black !important;
  font-family: 'OpelNext', serif !important;
  border-radius: 16px !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #cccccc !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: black !important;
    border-radius: 0 !important;
  }
`;

const SsgBaseTooltipStyle = styled(BaseTooltipStyle)`
  position: relative;
  cursor: pointer;
  margin: 0;
  color: #222 !important;
  border-color: transparent !important;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-transform: none !important;
  font-family: 'SansPro', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #c7c8ca !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #2f2c4d !important;
    border-radius: 0 !important;
  }
`;

const IsuBaseTooltipStyle = styled(BaseTooltipStyle)`
  position: relative;
  cursor: pointer;
  margin: 0;
  color: #222 !important;
  border-color: transparent !important;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  font-family: 'SansPro', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #c7c8ca !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #ff0000 !important;
    border-radius: 0 !important;
  }
`;

const FiatBaseTooltipStyle = styled(BaseTooltipStyle)`
  position: relative;
  cursor: pointer;
  font-size: 20px;
  margin: 0;
  padding: 12px !important;
  border-color: transparent !important;
  border-radius: 12px !important;
  color: black !important;
  font-family: 'Poppins', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #e0e0e0 !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #547496 !important;
    border-radius: 2px !important;
  }
`;

const LanciaBaseTooltipStyle = styled(BaseTooltipStyle)`
  position: relative;
  cursor: pointer;
  font-size: 20px;
  margin: 0;
  padding: 12px !important;
  border-color: transparent !important;
  border-radius: 12px !important;
  color: #222 !important;
  font-family: 'Montserrat', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #e0e0e0 !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #787878 !important;
    border-radius: 2px !important;
  }
`;

const JeepBaseTooltipStyle = styled(BaseTooltipStyle)`
  position: relative;
  cursor: pointer;
  font-size: 20px;
  margin: 0;
  padding: 12px !important;
  border-color: transparent !important;
  color: black !important;
  line-height: 140%;
  font-family: 'Roboto', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #e0e0e0 !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #787878 !important;
    border-radius: 0 !important;
  }
`;

const AlfaBaseTooltipStyle = styled(BaseTooltipStyle)`
  position: relative;
  cursor: pointer;
  font-size: 20px;
  margin: 0;
  padding: 12px !important;
  border-color: transparent !important;
  font-family: 'Helvetica', serif !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #e0e0e0 !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #787878 !important;
    border-radius: 0 !important;
  }
`;

const AbarthBaseTooltipStyle = styled(BaseTooltipStyle)`
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  padding: 12px !important;
  background-color: #000000 !important;
  position: relative;
  cursor: pointer;
  margin: 0;
  color: white !important;
  font-family: 'Abarth', serif !important;
  border-radius: 8px !important;

  .ScrollbarsCustom-TrackY {
    top: 0 !important;
    width: 4px !important;
    height: 100% !important;
    background-color: #e0e0e0 !important;
  }

  .ScrollbarsCustom-Thumb {
    width: 4px !important;
    height: 48px !important;
    background-color: #787878 !important;
    border-radius: 2px !important;
  }
`;

const AbarthTooltip = (props: any) => {
  return (
    <AbarthBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 234 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </AbarthBaseTooltipStyle>
  );
};

const BaseTooltip = (props: any) => {
  return (
    <BaseTooltipStyle style={props.styles}>
      <RichText disableOverflow={true} content={props.text} />
      <Arrow />
    </BaseTooltipStyle>
  );
};

const CitTooltip = (props: any) => {
  return (
    <CitBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 143 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </CitBaseTooltipStyle>
  );
};

const PeuTooltip = (props: any) => {
  return (
    <PeuBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 136 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </PeuBaseTooltipStyle>
  );
};

const DsTooltip = (props: any) => {
  return (
    <DsBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 304, height: 220 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow borderColor={'#9d8c83'} />
    </DsBaseTooltipStyle>
  );
};

const OpelTooltip = (props: any) => {
  return (
    <OpelBaseTooltipStyle style={props.styles}>
      <div
        style={{
          width: 285,
          maxHeight: 143,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <RichText disableOverflow={true} content={props.text} />
      </div>
      <Arrow />
    </OpelBaseTooltipStyle>
  );
};

const SsgTooltip = (props: any) => {
  return (
    <SsgBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 108 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </SsgBaseTooltipStyle>
  );
};

const IsuTooltip = (props: any) => {
  return (
    <IsuBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 108 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </IsuBaseTooltipStyle>
  );
};

const FiatTooltip = (props: any) => {
  return (
    <FiatBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 143 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </FiatBaseTooltipStyle>
  );
};

const LanciaTooltip = (props: any) => {
  return (
    <LanciaBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 143 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </LanciaBaseTooltipStyle>
  );
};

const JeepTooltip = (props: any) => {
  return (
    <JeepBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 234 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </JeepBaseTooltipStyle>
  );
};

const AlfaTooltip = (props: any) => {
  return (
    <AlfaBaseTooltipStyle style={props.styles}>
      <Scrollbar style={{ width: 285, height: 240 }}>
        <RichText disableOverflow={true} content={props.text} />
      </Scrollbar>
      <Arrow />
    </AlfaBaseTooltipStyle>
  );
};

const AdminTooltip = styled(BaseTooltip)``;

export interface CustomTooltipProps {
  text: any;
  brand: Brand;
  styles: any;
}
export const CustomTooltip = ({ text, brand, styles }: CustomTooltipProps) => {
  switch (brand) {
    case 'abarth':
      return <AbarthTooltip styles={styles} text={text} />;
    case 'peugeot':
      return <PeuTooltip styles={styles} text={text} />;
    case 'jeep':
      return <JeepTooltip styles={styles} text={text} />;
    case 'alfaromeo':
      return <AlfaTooltip styles={styles} text={text} />;
    case 'opelold':
    case 'opel':
      return <OpelTooltip styles={styles} text={text} />;
    case 'ds':
      return <DsTooltip styles={styles} text={text} />;
    case 'fiat':
      return <FiatTooltip styles={styles} text={text} />;
    case 'citroen':
      return <CitTooltip styles={styles} text={text} />;
    case 'ssangyong':
      return <SsgTooltip styles={styles} text={text} />;
    case 'isuzu':
      return <IsuTooltip styles={styles} text={text} />;
    case 'admin':
      return <AdminTooltip styles={styles} text={text} />;
    case 'lancia':
      return <LanciaTooltip styles={styles} text={text} />;
    default:
      return <BaseTooltip styles={styles} text={text} />;
  }
};
